<template>
  <div id="app">
    <nav class="navbar navbar-inverse navbar-fixed-top">
        <div class="header-alpha visible-md-block visible-lg-block">
            <div class="container">
                <ul class="nav navbar-nav navbar-right">
                    <li><a href="https://request-info.swau.edu/">REQUEST INFO</a>
                    </li>
                    <li><a href="https://forms.swau.edu/visit">VISIT</a>
                    </li>
                    <li><a href="https://www.swau.edu/admissions">APPLY</a>
                    </li>
                    <li><a href="https://www.swau.edu/you-make-difference">GIVE</a>
                    </li>
                    <li><a href="https://www.swau.edu/alumni">ALUMNI</a>
                    </li>
                    <li><a href="https://www.swau.edu/search"><span class="fa fa-search" style="margin-right: 5px"></span>SEARCH</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="header-beta">
            <div class="container">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#swau-navbar-collapse" aria-expanded="false"><span class="sr-only">Toggle navigation</span> <span class="fa fa-bars" style="font-size: 26px"></span>
                    </button>
                    <a class="navbar-brand" href="https://www.swau.edu"><img src="https://app.swau.edu/images/logo.png"></a>
                </div>
                <div class="collapse navbar-collapse" id="swau-navbar-collapse">
                    <ul class="nav navbar-nav navbar-right">
                        <li><a href="https://www.swau.edu/about">About</a>
                        </li>
                        <li><a href="https://www.swau.edu/admissions-aid">Admissions &amp; Aid</a>
                        </li>
                        <li><a href="https://www.swau.edu/academics">Academics</a>
                        </li>
                        <li><a href="https://www.swau.edu/campus-life">Campus Life</a>
                        </li>
                        <li><a href="https://www.swau.edu/events">Events</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
    <div class="breadcrumbs">
        <div class="container"><a href="https://www.swau.edu" style="margin-right: 5px"><span class="fa fa-home"></span></a>/ <a href="/discrimination">Discrimination / Sexual Misconduct Complaint Form</a></div>
    </div>

    <router-view></router-view>

    <footer class="footer" role="contentinfo">
        <div class="container">
            <div class="row">
                <div class="col-md-4 footer-left">
                    <p>
                        <a href="https://www.swau.edu"><img src="https://app.swau.edu/images/footer-logo.png" alt="Southwestern Adventist University"></a>
                    </p>
                    <p style="padding-bottom: 30px"><a href="https://www.swau.edu/sitemap">Site Map</a> | <a href="https://www.swau.edu/copyright">Copyright</a>
                    </p>
                </div>
                <div class="col-md-4 footer-center">
                    <h2>Address</h2>
                    <p style="padding-bottom: 30px"><a href="https://www.google.com/maps/place/Southwestern+Adventist+University/@32.3963724,-97.3290354,17z/data=!3m1!4b1!4m2!3m1!1s0x864e446bbc5fbce9:0x9b338d9e54e8ef6c" target="_blank">100 W Hillcrest Street<br>Keene, TX 76059</a>
                    </p>
                    <h2>Phone</h2>
                    <p style="padding-bottom: 30px"><a href="tel:8004332240">800.433.2240</a>
                        <br><a href="tel:8176453921">817.645.3921</a>
                    </p>
                </div>
                <div class="col-md-4 footer-right">
                    <h2>Connect with us</h2>
                    <nav>
                        <ul class="social-icons icon-circle icon-rotate list-unstyled list-inline">
                            <li><a href="http://www.facebook.com/southwestern.adventist.university" target="_blank"><i class="fa fa-facebook"></i></a>
                            </li>
                            <li><a href="http://twitter.com/southwesternau" target="_blank"><span class="fa fa-twitter"></span></a>
                            </li>
                            <li><a href="http://www.youtube.com/user/SouthwesternAU" target="_blank"><span class="fa fa-youtube"></span></a>
                            </li>
                            <li><a href="http://vimeo.com/swau" target="_blank"><span class="fa fa-vimeo"></span></a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </footer>

  </div>
</template>

<script>
require('bootstrap')
export default {
  name: 'app'
}
</script>


<style src="./styles/swau.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue